var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
var sendToAnalytics = /** @class */ (function (_super) {
    __extends(sendToAnalytics, _super);
    function sendToAnalytics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sendToAnalytics = function (analyticsData) {
            try {
                if (window.hasOwnProperty('dataLayer')) {
                    window.dataLayer.push(__assign({ type: 'Event' }, analyticsData));
                }
                if (window.hasOwnProperty('ga')) {
                    window.ga('send', {
                        hitType: analyticsData.type || 'event',
                        eventCategory: analyticsData.category,
                        eventAction: analyticsData.action,
                        eventLabel: analyticsData.label
                    });
                }
                // submit facebook event on successful ninjaforms submission also.
                if (window.hasOwnProperty('fbq')) {
                    window.fbq('track', 'Contact');
                }
            }
            catch (e) {
                if (e instanceof Error) {
                    console.error('sendToAnalytics error:', e.message);
                }
            }
        };
        return _this;
    }
    sendToAnalytics = __decorate([
        Component
    ], sendToAnalytics);
    return sendToAnalytics;
}(Vue));
export { sendToAnalytics };
